import { Modal } from "@mui/material";
import { ContentModal } from "../../Surfaces/ContentModal/ContentModal";
import ConfirmStove from "../ModalReconnect/components/ConfirmStove/ConfirmStove";

export default function ModalConfirmStove({
    open,
    onClose,
    service,
    onConfirm,
}) {
    const handleClose = () => {
        onClose && onClose();
    };

    return (
        <Modal open={open} onClose={handleClose} disableAutoFocus={true}>
            <ContentModal
                minWidth={"675px"}
                style={{ width: "auto", paddingTop: "30px" }}
                borderRadius={"8px"}
            >
                <ConfirmStove
                    service={service}
                    onChangePage={(page, service) => {
                        if (page === "confirmService" && onConfirm) {
                            onConfirm(service);
                        }
                    }}
                />
            </ContentModal>
        </Modal>
    );
}
